import { render, staticRenderFns } from "./ManutencaoNotaFiscalDetalhes.vue?vue&type=template&id=493b2d5b"
import script from "./ManutencaoNotaFiscalDetalhes.vue?vue&type=script&lang=js"
export * from "./ManutencaoNotaFiscalDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports